import * as React from 'react';
import { UIBasic, IPropsBasic } from 'kts-scaffold-framework/modules';
import { connect } from 'kts-platform-frame/redux';
import ReduxState, { } from 'kts-platform-frame/redux/ReduxState'; 
import ModulesState from './Modules.State'; 
import ModulesAction from './Modules.Action';
import { Checkbox, Tooltip} from 'antd'; 
import { MyStore, reducers } from 'kts-platform-frame/redux';

const css = require('./index.scss');  
/** Redux接口 */
interface IReduxStatePart {
}

/** Props接口 */
interface IProps extends IReduxStatePart, IPropsBasic {
    getTitle: any; 
    checkIsSelect: any;
    onCheckChange: any;
    isCheck: boolean;
    loadingUrls: any;
    keywords: string;
}

/** 绑定全局数据到props */ 
@ModulesAction.uiconnect
@connect((state: ReduxState): IReduxStatePart => ({
}))
export default class CompanyCheck extends UIBasic<IProps, ModulesState> {

    constructor(props: IProps) {
        super(props, ModulesAction);
    }   
    render() {   
        const {sortList=[]} = this.modulesState;  
        const {isCheck, loadingUrls, keywords} = this.props;    
        return ( 
            <div>  
                {keywords && sortList.length === 0 && <div className={css.centertxt}>搜索无结果</div>}
                {sortList.map((itemclass, classindex) => {
                    return (
                            <div className={css.letterclass} key={classindex}>
                                <div className={css.letters}>{itemclass.letter && itemclass.letter.toUpperCase()}</div> 
                                {itemclass.data && itemclass.data.map((item, index) => {
                                    return (
                                        <Tooltip key={index} title={this.props.getTitle(item, index)} placement='leftTop'>
                                            <div className={`${css.moretext}`}> 
                                                {isCheck === true ?   
                                                    <Checkbox checked={this.props.checkIsSelect(item)} onChange={this.props.onCheckChange} value={item}> 
                                                        <span className={`${css.mynetworklist}`}  style={{cursor: 'pointer' }}  dangerouslySetInnerHTML={{ __html: this.props.getTitle(item, index).replace(new RegExp(keywords,'g'), "<font style='background: yellow'>"+keywords+"</font>") }} />
                                                    </Checkbox>
                                                    : 
                                                    <span className={`${css.mynetworklist}`}  style={{cursor: 'pointer' }}  dangerouslySetInnerHTML={{ __html: this.props.getTitle(item, index).replace(new RegExp(keywords,'g'), "<font style='background: yellow'>"+keywords+"</font>") }} />
                                                }
                                            </div>
                                        </Tooltip>
                                    );
                                })}
                            </div>
                        );
                    })
                }
            </div>
        );
    }   
    private hide = () => {   
        MyStore.instance.dispatch(reducers.rightPopUps.ActionTypes.removeHide, null);
    }
}



// WEBPACK FOOTER //
// ./src/node_modules/kts-platform-frame/display/part/CompanySelection/CompanyCheck.tsx